import * as React from 'react';
import { ContentState } from 'draft-js';

var DraftMentionItem = function DraftMentionItem(_ref) {
    var contentState = _ref.contentState,
        entityKey = _ref.entityKey,
        children = _ref.children;

    var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
        id = _contentState$getEnti.id;

    return React.createElement(
        'a',
        { href: '/profile/' + id },
        children
    );
};

DraftMentionItem.propTypes = {
    children: PropTypes.node.isRequired,
    // React.ChildrenArray<React.Element<any>> unsupported by babel-plugin-flow-react-proptypes
    contentState: function contentState() {
        return (typeof ContentState === 'function' ? PropTypes.instanceOf(ContentState).isRequired : PropTypes.any.isRequired).apply(this, arguments);
    },
    entityKey: PropTypes.string.isRequired
};
export default DraftMentionItem;
import PropTypes from 'prop-types';